import { FC, useState, useEffect, useRef } from 'react';
import { Modal } from 'antd';
import { getProductSpu } from '@base/product/services';
import { ISpuInfo } from 'base/interfaces/product';
import Message from '@base/lib/Message';
import { RowLoading } from '@base/lib/ThemeLoadingV2';
import { ProductDetail, IProductDetailProps } from '@app/common/ProductDetailPopup/ProductDetail';
import { IReviewPage } from 'mod/review/interface';
import { getFirstReviewPage } from 'mod/review/service';

export type IProductDetailPopupProps = {
    visible: boolean;
    onClose: () => void;
    variantId?: string;
    elements?: IProductDetailProps['elements'];
    hiddenElements?: IProductDetailProps['hiddenElements'];
    pageFrom?: string;
};

export const ProductDetailPopup: FC<IProductDetailPopupProps> = props => {
    const { visible, onClose, variantId, elements, hiddenElements, pageFrom } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [spu, setSpu] = useState<ISpuInfo>();
    const [reviewPage, setReviewPage] = useState<IReviewPage>();
    const variantIdRef = useRef<string>('');

    const getData = async (variantId: string) => {
        setLoading(true);
        try {
            const [spuRes, reviewPageRes] = await Promise.all([
                getProductSpu({ variantId, pageFrom }),
                getFirstReviewPage(variantId)
            ]);
            setSpu(spuRes);
            setReviewPage(reviewPageRes);
        } catch (e) {
            console.log('err', e);
            Message.error(e.message);
        }
        setLoading(false);
    }

    useEffect(() => {
        if (visible && variantId && variantId !== variantIdRef.current) {
            variantIdRef.current = variantId;
            getData(variantId);
        }
    }, [visible, variantId]);


    return (
        <Modal
            destroyOnClose
            width={1240}
            open={visible}
            onCancel={onClose}
            footer={false}
            centered
        >
            {loading
                ? <RowLoading/>
                : (
                    spu ? (
                        <ProductDetail
                            spu={spu}
                            initialReviewPage={reviewPage}
                            variantId={variantId as string}
                            elements={elements}
                            hiddenElements={hiddenElements}
                        />
                    ) : null
                )
            }
        </Modal>
    )
};